import API from '@/api/permission/resource';
import loginAPI from '@/api/login';
import Layout from '@/views/layout';
import Layout2 from '@/views/spot-market/market-dynamics';
import router from './index';
import store from '@/store';
import { Message } from 'element-ui';
import { UserUtil } from '@/utils/user-utils';
import Cookies from 'js-cookie';
import { localStorageUtil } from '@/utils/storage-util';

const loadView = (view) => {
  // 路由懒加载
  return (resolve) => require([`@/views/${view}`], resolve);
};

function transformRouter(asyncRoute) {
  let resultRouter = [];
  asyncRoute.forEach((route) => {
    let obj = {};
    const { cnName, componentPath, url, icon, hidden } = route;
    obj.meta = {
      title: cnName,
      icon: icon ? icon : ' ',
    };
    obj.hidden = hidden;
    obj.name = url;
    if (route.children.length) {
      obj.component = Layout;
      obj.path = `/${url}`;
      obj.redirect = 'noRedirect';
      obj.alwaysShow = true;
      obj.children = transformRouter(route.children);
    } else {
      obj.component = loadView(componentPath);
      obj.path = url;
    }
    if (
      route.id == '910300000173' ||
      route.id == '910300000177' ||
      route.id == '910300000183' ||
      route.id == '910300000186' ||
      route.id == '910300000131' ||
      route.id == '910300000214' ||
      route.id == '910300000250'
    ) {
      obj.component = Layout2;
      obj.path = url;
    }
    resultRouter.push(obj);
  });
  return resultRouter;
}

export async function generateRouters() {
  let cookieToken = Cookies.get('TOKEN');
  let localToken = localStorageUtil.get('TokenKey');

  if (cookieToken) handlerThirdLoginCheck();
  else await getRouterList();
}
//请求菜单
async function getRouterList() {
  let asyncRoute = [];
  const res = await API.queryResources();
  if (res.code == 401) {
    if (res.msg) {
      Message.error(res.msg);
    }
    // UserUtil.removeToken();
    window.location.reload();
    return;
  }
  if (res.code == 200 && res.data) {
    asyncRoute = res.data;
  }

  // 通过接口生成路由
  const finallyRouter = transformRouter(asyncRoute);
  store.commit('permission/SET_ROUTES', finallyRouter);
  finallyRouter.forEach((fr) => {
    router.addRoute(fr);
  });

  // 常规生成路由
  // const accessRoutes = await store.dispatch(
  //   'permission/generateRoutes',
  //   'admin',
  // );
  // for (const item of accessRoutes) {
  //   router.addRoute(item);
  // }
}
// 4A系统跳转登录校验
function handlerThirdLoginCheck() {
  let params = {
    id: Cookies.get('ID'),
    code: Cookies.get('CODE'),
    token: Cookies.get('TOKEN'),
  };
  loginAPI.thirdLoginCheck(params).then((res) => {
    let { code, data } = res;
    if (code === 200) {
      const base64Url = data.split('.')[1]; // 获取载荷部分
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // Base64URL 到 Base64 的转换
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join(''),
      );
      const decodedToken = JSON.parse(jsonPayload);
      localStorageUtil.set('areaCode', decodedToken.areacode);
      localStorageUtil.set('cityCode', decodedToken.city);
      localStorageUtil.set('roleIds', decodedToken.role_ids);
      UserUtil.setToken(data);
      getRouterList();
    }
  });
}
